module.exports = __webpack_public_path__ + "static/media/video-1.0451ca31.webm";


//////////////////
// WEBPACK FOOTER
// ./src/videos/video-1.webm
// module id = 154
// module chunks = 0